import React from 'react';

const AnimatedButton: React.FC<{ children: React.ReactNode; onClick?: () => void }> = ({ children, onClick }) => {
    return (
        <div>
            <style>{`
                @keyframes shake {
                    0%, 10%, 65%, 100% {
                        transform: rotate(0deg) scale(1.0);
                    }
                    30%, 40% {
                        transform: rotate(-1deg) scale(1.05);
                    }
                    50% {
                        transform: translateX(5px);
                    }
                    35%, 45% {
                        transform: rotate(1deg) scale(1.05);
                    }
                }

                .animate-shake {
                    animation: shake 2s ease-in-out infinite;
                }
            `}</style>
            <button
                onClick={onClick}
                className="mt-4 bg-black w-full text-white text-xl py-4 px-10 rounded-full font-bold m-2 transform transition-transform duration-300  animate-shake"
            >
                {children}
            </button>
        </div>
    );
};

export default AnimatedButton;